import React from "react"; // {useState}
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/components/datePickerDropdown.css";
import Calendar from "../../assets/image/icones/datePickerDropdown/calendar.svg";
import { withTranslation } from "react-i18next";
import moment from "moment-timezone";
import DatePickerLocale from "./DatePickerLocale";

class RecruitmentsDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateText: "",
      dateValue: null,
    };
    this.notInitialized = true;
    this.datepicker = null;
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault();
    const val = e.target.value;
    const newMoment = moment(val, "DD/MM/YYYY");
    let nextState = { ...this.state, dateText: val };
    if (newMoment.isValid()) {
      const newDate = newMoment.toDate();
      nextState.dateValue = newDate;
      this.datepicker.setSelected(newDate);
      this.props.onChange(newDate);
    }
    this.setState(nextState);
  };

  handleChangeDatePicker = (date) => {
    this.setState({
      dateText: moment(date).locale(this.props.i18n.language).format("LL"),
      dateValue: date,
    });
    this.props.onChange(date);
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.i18n.language !== this.props.i18n.language &&
      this.state.dateValue
    ) {
      this.setState({
        dateText: moment(this.state.dateValue)
          .locale(this.props.i18n.language)
          .format("LL")
      });
      return;
    }

    if (
      this.notInitialized &&
      prevProps.value !== this.props.value &&
      !this.state.dateText
    ) {
      this.notInitialized = false;
      this.setState({
        dateText: this.props.selectedState
          ? moment(this.props.selectedState)
              .locale(this.props.i18n.language)
              .format("LL")
          : this.props.value,
        dateValue: this.props.selectedState,
      });
    }
  }

  render() {
    return (
      <div className="container_datePickerDropdown arh-relative selectDateDropdown">
        <img
          alt="btn Calendar"
          className="arh-absolute icones_close_calendar_right arh-w-[20px] "
          src={Calendar}
        />
        <DatePickerLocale
          id={this.props.id}
          selected={this.state.dateValue}
          value={this.state.dateText}
          onChange={this.handleChangeDatePicker}
          name={this.props.name}
          placeholderText={this.props.placeholder}
          className={
            "arh-font-poppins arh-font-normal input_datepicker_dropdown_page " + this.props.className
          }
          showMonthDropdown
          showYearDropdown
          dateFormatCalendar="MMMM"
          autoComplete="off"
          yearDropdownItemNumber={30}
          onChangeRaw={this.handleDateChangeRaw}
          minDate={new Date()}
          ref={(datepickerRef) => (this.datepicker = datepickerRef)}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}
export default withTranslation(null, { withRef: true })(RecruitmentsDatePicker);
